import { render } from "./DicomWebViewer.vue?vue&type=template&id=01a042b6&scoped=true&ts=true"
import script from "./DicomWebViewer.vue?vue&type=script&lang=ts"
export * from "./DicomWebViewer.vue?vue&type=script&lang=ts"

import "./DicomWebViewer.vue?vue&type=style&index=0&id=01a042b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a042b6"]])

export default __exports__